// extracted by mini-css-extract-plugin
export default {"product_body_box":"HeroBody_product_body_box__shjqN","product_body_title":"HeroBody_product_body_title__mAEtS","product_body_description":"HeroBody_product_body_description__1OO0K"};